import type { VersionedWording } from '@/lib/versioned-labels';
import { NOYAU_TEXTS_NAME } from '@matter_extractor/shared';

/**
 * How the versioned layer names « Les textes des noyaux » (noyau.md §6, issue
 * #148), everywhere it has to.
 *
 * A SINGLETON (N8): no list, no card, no creation box, no retirement, no
 * rename. So half of `VersionedWording` names gestures this object never
 * offers - the `settings` logement renders neither the retirement panel nor its
 * box - and those sentences are written anyway, in French and true, because a
 * wording that lied in an unreachable corner would be the first thing a later
 * lot copies.
 *
 * The prefixes are `noyaux`: every mark of the tab is `noyaux-...`
 * (`noyaux-entete`, `noyaux-enregistrer`, `noyaux-carte`), which is what
 * `reglages-noyaux.spec.ts` and `screenshots-reglages-noyaux.mjs` read.
 * Unaccented, like the four before it, so a spec can type them.
 */
export const NOYAU_TEXTS_WORDING: VersionedWording = {
  kind: 'noyau-texts',
  entity: 'noyaux',
  list: 'noyaux',
  noun: ['objet des textes des noyaux', 'objets des textes des noyaux'],
  newTitle: NOYAU_TEXTS_NAME,
  createLabel: 'Écrire les textes des noyaux',
  saveHintNew: 'Crée la v1. Inactif tant que les dix-huit textes ne sont pas remplis.',
  // Until something is typed. Then the layer says when this browser kept it,
  // or that it refused to (`draftStateSentence`, review of !462).
  draftStateNew: 'Aucune version encore : la saisie est gardée dans ce navigateur jusqu’à la v1.',
  // Names no kind, and PROMISES the new version, which only this object may:
  // its lists are read by the tag of each reference (`referentsByTag`,
  // noyau.md §6.5), so the experiences drawn above it are the ones that read it.
  developmentHint: (nextNumber) =>
    `Leurs sessions neuves liront la v${nextNumber} ; les sessions en cours ne changent pas.`,
  subject: (name) => name,
  retirement: {
    panelTitle: 'Les textes des noyaux ne se retirent pas',
    retiredTitle: 'Textes des noyaux retirés',
    confirmLabel: 'Retirer les textes des noyaux',
    panelHint: () => (
      <>
        Un seul objet pour les six noyaux, sans retrait : une expérience qui porte un bloc Noyau les
        lit toujours.
      </>
    ),
    retiredHint: (_name, day) => <>Retirés le {day}.</>,
    warningTitle: () => 'Chaque expérience à bloc Noyau cessera de démarrer',
  },
  refusal: {
    nameTaken: 'Les textes des noyaux portent un nom fixe.',
    nameTakenBy: () => 'Les textes des noyaux portent un nom fixe.',
    retired: 'Les textes des noyaux sont retirés.',
  },
};
